/* eslint-disable camelcase */

import { pick } from 'lodash-es';

import { request, fetch } from '../utils/request';

const PRODUCTION_BASE = process.env.TAGBOARD_LIVE_URL;

const ProductionServiceV2 = {
  /**
   * Fetch list of productions (paginated)
   * @param {Number} opts.page - Page number
   * @param {Number} opts.limit - Amount of productions to fetch
   * @param {Number} opts.owner - ID of the production owner
   */
  getProductionsPaged(opts = {}) {
    const {
      page = 1,
      limit = 50,
      owner = null,
    } = opts;

    const params = {
      pageNumber: page,
      pageSize: limit,
    };

    if (owner) {
      params.owner = owner;
    }

    const urlParams = new URLSearchParams(params);

    return fetch(`${PRODUCTION_BASE}/api/v2/productions?${urlParams}`);
  },

  // Pointing to our New Route
  searchProductions(payload) {
    return request({
      url: `${PRODUCTION_BASE}/api/v2/productions/search`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(payload),
    });
  },

  // Pointing to our New Route
  getTagsForUser(owner) {
    return request({
      url: `${PRODUCTION_BASE}/api/v2/tags${owner ? `?owner=${owner}` : ''}`,
      type: 'GET',
    });
  },

  // Pointing to our New Route
  getProduction(productionId) {
    return fetch(`${PRODUCTION_BASE}/api/v2/productions/${productionId}?merge_deltas=true`);
  },

  // Pointing to our New Route
  createProduction(production) {
    return request({
      type: 'POST',
      url: `${PRODUCTION_BASE}/api/v2/productions`,
      contentType: 'application/json',
      data: JSON.stringify(production),
    });
  },

  /**
   * The API request for flagging (starring) a production.
   * NOTE: Flagged productions are scoped per-user.
   * @param {Number}  productionId - The id of the production to be flagged.
   * @param {Boolean} flagged - True to flag a production, False to unflag it.
   * @param {Number}  userId - The id of the user that the production should be flagged for.
   * @returns {*}
   */
  flagProduction(productionId, flagged, userId) {
    return request({
      type: 'PUT',
      url: `${PRODUCTION_BASE}/api/v2/productions/${productionId}/flag`,
      contentType: 'application/json',
      data: JSON.stringify({ flagged, userId }),
    });
  },

  // Pointing to our New Route
  updateProduction(production) {
    if (!production._id) {
      throw new Error(`Attempting to update production without _id: ${JSON.stringify(production, 0, 2)}`);
    }

    return request({
      type: 'PUT',
      url: `${PRODUCTION_BASE}/api/v2/productions/${production._id}`,
      contentType: 'application/json',
      data: JSON.stringify(
        pick(production, [
          'xDimension',
          'yDimension',
          'title',
          'backgroundColor',
          'transition',
          'index',
          'sub_index',
          'tags',
          'looped',
          'muted',
          'videoPlaying',
          'playing',
          'kiosk_mode',
          'flagged',
        ]),
      ),
    });
  },

  deleteProduction(productionId) {
    return fetch(`${PRODUCTION_BASE}/api/v2/productions/${productionId}`, {
      method: 'DELETE',
    });
  },

  // Pointing to our New Route
  restoreProduction(productionId) {
    return fetch(`${PRODUCTION_BASE}/api/v2/productions/${productionId}/restore`, {
      method: 'PUT',
    });
  },

  // Get User Permissions
  getUserPermissions(userId) {
    return fetch(`${PRODUCTION_BASE}/api/v2/permissions/${userId}`);
  },
};

export default ProductionServiceV2;
